import { Typography } from "@mui/material";
import classNames from "classnames";

import { FilterMatch } from "../../Sidebar/filterResult";
import { HighlightedText } from "../../Sidebar/HighlightedText";

import styles from "./MessagePathLabel.module.css";

export interface MessagePathLabelProps {
  className?: classNames.Argument;
  dataType: string;
  label: string;
  match?: FilterMatch;
}

/**
 * Renders a label for a message path.
 */
export function MessagePathLabel(props: MessagePathLabelProps) {
  const { className, dataType, label, match } = props;

  return (
    <div className={classNames(className, styles.labelContainer)}>
      <p
        className={classNames(
          "ph-no-capture",
          styles.hideOverflow,
          styles.label,
        )}
      >
        <HighlightedText text={label} match={match} />
        <Typography
          component={"span"}
          className={classNames(styles.dataTypeLabel, styles.hideOverflow)}
          color="text.secondary"
        >
          {dataType}
        </Typography>
      </p>
    </div>
  );
}
